
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import descriptors from './descriptors.js';
import './object-define-property.js';
import createPropertyDescriptor$1 from './create-property-descriptor.js';
import { __exports as objectDefineProperty } from '../../../_virtual/object-define-property.js';

var DESCRIPTORS = descriptors;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$1;

var createProperty = function (object, key, value) {
  if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};

export { createProperty as default };
//# sourceMappingURL=create-property.js.map
